import type { FC } from 'react';
import React from 'react';
import styled from 'styled-components';

interface IMobile {
  isMobile?: boolean;
}

interface IEmptyBlock extends IMobile {
  className: string;
  icon: any;
  title: string;
  subtitle: string;
}

const EmptyBlock: FC<IEmptyBlock> = ({
  className = '',
  isMobile = false,
  icon,
  title,
  subtitle,
}) => (
  <StyledContainer className={className} isMobile={isMobile}>
    {icon}
    <StyledHeader isMobile={isMobile}>{title}</StyledHeader>
    <StyledText isMobile={isMobile}>{subtitle}</StyledText>
  </StyledContainer>
);

const StyledContainer = styled.div<IMobile>`
  padding: ${(props) => (props.isMobile ? '5px 25px 15px' : '50px 0 100px')};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const StyledHeader = styled.div<IMobile>`
  margin-bottom: 8px;
  font-size: ${(props) => (props.isMobile ? '18px' : '22px')};
  font-weight: bold;
  color: ${(props) => props.theme.colors.blackBase};
`;

const StyledText = styled.div<IMobile>`
  font-size: ${(props) => (props.isMobile ? '13px' : '14px')};
  text-align: center;
  color: ${(props) => props.theme.colors.blackLight};
`;

export default EmptyBlock;
